import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from "@material-ui/lab";
import Resume from "../../settings/resume.json";

const useStyles = makeStyles((theme) => ({
    speedDial: {
        position: "absolute",
        top: theme.spacing(6),
        right: theme.spacing(6),
    },
    iconColor: {
        color: theme.palette.foreground.default,
    },
    platformGoogle: {
        color: '#DB4437',
    },
    platformLinkedIn: {
        color: '#0A66C2',
    },
    platformGithub: {
        color: theme.palette.type === 'dark' ? '#ffffff' : '#111111',
    },
    platformMedium: {
        color: '#000000',
    },
    platformLeetCode: {
        color: '#FFA116',
    },
}));

export const SpeedDials = () => {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const actionIcons = Resume.basics.profiles.map((action) => {
        let platformClass = '';
        if (action.network === 'Google') platformClass = classes.platformGoogle;
        else if (action.network === 'LinkedIn') platformClass = classes.platformLinkedIn;
        else if (action.network === 'GitHub') platformClass = classes.platformGithub;
        else if (action.network === 'Medium') platformClass = classes.platformMedium;
        else if (action.network === 'LeetCode') platformClass = classes.platformLeetCode;

        const iconClass = `${action.x_icon} ${platformClass}`;

        return (
            <SpeedDialAction
                key={action.network.toLowerCase()}
                icon={<i className={iconClass}></i>}
                tooltipTitle={action.network}
                onClick={handleClose}
                href={action.url}
                target="_blank"
                rel="noopener noreferrer"
                underline="none"
                color="inherit"
            />
        );
    });

    return (
        <>
            <SpeedDial
                ariaLabel="SpeedDial"
                className={classes.speedDial}
                hidden={false}
                icon={<SpeedDialIcon />}
                onClose={handleClose}
                onOpen={handleOpen}
                open={open}
                direction="down"
            >
                {actionIcons}
            </SpeedDial>
        </>
    );
};
